export default function (filterItems) {
    return [...filterItems].sort((a, b) => a.name.localeCompare(b.name, 'pl', { numeric: true }));
}
